import React from 'react';
import { Link } from 'react-router-dom';
import './Memories.css';
import { albumDetailsMap } from './AlbumConstants';
// Centralized album data with photo folder info

const Memories = () => (
  <div className="memories-container">
    <h1>Memories & Events</h1>
    <p>
      Explore our curated albums capturing the rich history and memorable events
      of Rolling Thunder Cycles. Click on any album to relive the moments we've
      shared with our community over the years.
    </p>
    <div className="memories-albums">
      {Object.keys(albumDetailsMap).map((key) => {
          const album = albumDetailsMap[key];
          const bgImg =
            album.photoNames && album.photoNames.length > 0
              ? `/Assets/Photos/${encodeURIComponent(album.folder)}/${
                  album.photoNames[1]
                }`
              : undefined;
          const cardStyle = {
            minWidth: '260px',
            ...(bgImg
              ? {
                  backgroundImage: `url('${bgImg}')`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  color: '#fff',
                  textShadow: '0 2px 8px #000',
                  position: 'relative',
                  overflow: 'hidden',
                }
              : {}),
          };
          return (
            <Link
              to={`/memories/${key}`}
              className="memories-album-card"
              key={key}
              style={cardStyle}
            >
              <div
                className="memories-album-name"
                style={{
                  background: bgImg ? 'rgba(34,34,34,0.65)' : 'none',
                  borderRadius: '8px',
                  padding: '1.2rem 0.5rem',
                  position: 'relative',
                  zIndex: 1,
                }}
              >
                {album.name}
              </div>
            </Link>
          );
        })}
    </div>
  </div>
);

export default Memories;
